import { Card, Typography } from "@material-tailwind/react";
import SvgMapper from "../features/common/SvgMapper";

const adminDefaultStats = [
  { title: "Scheduled Interviews", value: "0", subtitle: "last month", color: "text-blue-600", icon: SvgMapper.calendar("w-6 h-6 text-blue-600"), bg: "bg-blue-50" },
  { title: "Expired Interviews", value: "0", subtitle: "last month", color: "text-amber-600", icon: SvgMapper.clock("w-6 h-6 text-amber-600"), bg: "bg-amber-50" },
  { title: "Completed Interviews", value: "0", subtitle: "last month", color: "text-green-600", icon: SvgMapper.logo("w-6 h-6 text-green-600"), bg: "bg-green-50" },
  { title: "Active Candidates", value: "0", subtitle: "last month", color: "text-purple-600", icon: SvgMapper.trendingUp("w-6 h-6 text-purple-600"), bg: "bg-purple-50" },
];

const studentDefaultStats = [
  { title: "Upcoming Interviews", value: "0", subtitle: "scheduled", color: "text-blue-600", icon: SvgMapper.calendar("w-6 h-6 text-blue-600"), bg: "bg-blue-50" },
  { title: "Completed Last Month", value: "0", subtitle: "last month", color: "text-green-600", icon: SvgMapper.logo("w-6 h-6 text-green-600"), bg: "bg-green-50" },
  { title: "Performance Score", value: "0", subtitle: "last month", color: "text-purple-600", icon: SvgMapper.trendingUp("w-6 h-6 text-purple-600"), bg: "bg-purple-50" },
  { title: "Total Interview Types", value: "0", subtitle: "available", color: "text-amber-600", icon: SvgMapper.clock("w-6 h-6 text-amber-600"), bg: "bg-amber-50" },
];

const mapAdminMetricsToStats = (data) => {
  if (!data || typeof data !== "object") return adminDefaultStats;
  return [
    { ...adminDefaultStats[0], value: String(data.scheduled_interviews_last_month ?? 0) },
    { ...adminDefaultStats[1], value: String(data.expired_interviews_last_month ?? 0) },
    { ...adminDefaultStats[2], value: String(data.completed_interviews_last_month ?? 0) },
    { ...adminDefaultStats[3], value: String(data.active_candidates_last_month ?? 0) },
  ];
};

const mapStudentMetricsToStats = (data) => {
  if (!data || typeof data !== "object") return studentDefaultStats;
  return [
    { ...studentDefaultStats[0], value: String(data.upcoming ?? 0) },
    { ...studentDefaultStats[1], value: String(data.completed_last_month ?? 0) },
    { ...studentDefaultStats[2], value: String(data.performance_score_last_month ?? 0) },
    { ...studentDefaultStats[3], value: String(data.total_interview_types ?? 0) },
  ];
};

const StatsCards = ({ metrics, variant = "admin" }) => {
  const data = metrics?.data;
  const stats = data
    ? variant === "student"
      ? mapStudentMetricsToStats(data)
      : mapAdminMetricsToStats(data)
    : variant === "student"
      ? studentDefaultStats
      : adminDefaultStats;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
      {stats.map((s, i) => (
        <Card key={i} className="relative p-6 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all">
          {/* Badge */}
          <span className="absolute top-3 right-3 bg-blue-100 text-blue-700 text-xs font-medium px-2 py-1 rounded-full">
            Last 1 Month
          </span>

          <div className="flex items-center justify-between">
            <div>
              <Typography variant="h6" className="text-sm font-medium text-gray-600">
                {s.title}
              </Typography>
              <Typography variant="h4" className="font-semibold text-gray-900">
                {s.value}
              </Typography>
              <Typography className={`text-sm ${s.color} mt-1`}>
                {s.subtitle}
              </Typography>
            </div>
            <div className={`p-3 rounded-lg ${s.bg}`}>
              {s.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default StatsCards;
